import { IComponentOptions } from "angular";
import { ProgressiveDefinitionMachinesViewComponentController } from "./controller";

export const vsComponentName = "progressiveDefinitionMachinesView";

export const progressiveDefinitionMachinesViewComponentOptions: IComponentOptions =
  {
    controller: ProgressiveDefinitionMachinesViewComponentController,
    controllerAs: "progressiveMachinesController",
    template: require("!html-loader!./index.html").default,
    bindings: {
      progressiveDefinition: "<",
    },
  };
